<template>
    <div>
        <el-popover
                ref="popover"
                placement="top-end"
                :visible-arrow="false"
                @show="show"
                @hide="hide"
                trigger="hover">
            <div class="arrangement-info-tooltip-wpr">
                <table class="table text-center arrangement-info">
                    <thead>
                    <tr class="text-hd">
                        <th class="text-center" width="80">阶段</th>
                        <th class="text-center" width="200">结果</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="border-row" v-for="(item, index) in baseData">
                        <td class="text-td">{{item.text}}</td>
                        <td class="text-td">{{item.value}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </el-popover>
        <span v-popover:popover style="font-size: 12px;"><span class="state-name">{{stateName}}</span><i class="el-icon-my-tishi color-warning"></i></span>
    </div>
</template>
<script type="text/javascript">
    import axios from 'axios'
    import { Loading } from 'element-ui'

    export default {
        data () {
            return {
                baseData: [{
                    text: '一面面试官',
                    value: '张三、李四、王五'
                }]
            }
        },
        props: {
            stateName: '',
            showIcon: {
                type: Boolean,
                default: true
            },
            id: ''
        },
        methods: {
            show () {
                this.loadingInstance = Loading.service({
                    target: document.querySelector('.arrangement-info-tooltip-wpr')
                })
                let CancelToken = axios.CancelToken
                this.source = CancelToken.source()
                this.ajax = axios.get('/employ/listEval.api?id=' + this.id, {
                    cancelToken: this.source.token,
                    'X-loadingOff': true
                }).then(res => {
                    this.baseData = res.result.list
                    this.loadingInstance.close()
                    this.ajax = null
                }).catch(() => {})
            },
            hide () {
                this.loadingInstance.close()
                if (this.ajax) {
                    this.source.cancel('不要啦，我关闭不看了')
                }
            }
        }
    }
</script>
<style lang="scss">
    .arrangement-info-tooltip-wpr {
        min-height : 50px;
    .text-hd {
        background : #11b95c;
        color      : #fff;
    th {
        padding : 3px 5px;
    }
    }
    .border-row {
        border-top    : 1px solid #ddd;
        border-bottom : 1px solid #ddd;
    }
    .text-td {
        padding : 3px 5px;
    }
    }
</style>


// WEBPACK FOOTER //
// arrangeTooltips.vue?61ec02ba